var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0959 0.200001L12.2959 9.4L21.4959 0.2L24.2959 3L13.7101 13.5858C12.9291 14.3668 11.6627 14.3668 10.8817 13.5858L0.295898 3L3.0959 0.200001Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomArrow);
export default __webpack_public_path__ + "static/media/custom_arrow.763ae027cd4f311691b94802deb64288.svg";
export { ForwardRef as ReactComponent };